module.exports = __webpack_public_path__ + "img/beijingse_8.aaf2e601.png";